import { render, staticRenderFns } from "./EditDeviceAccessGroup.vue?vue&type=template&id=67c474de"
import script from "./EditDeviceAccessGroup.vue?vue&type=script&lang=js"
export * from "./EditDeviceAccessGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports